import React from "react";
import { Row, Col } from "react-bootstrap";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CK_CONFIGS } from "../../../../../../configs";

const TabsContent = () => {
  return (
    <>
      <div className="border rounded-3">
        <Row className="g-0">
          <Col lg={9}>
            <div className="tab-header">
              <h5 className="font-14 font-weight-bold heading-color">
                Job Performance
              </h5>
            </div>
          </Col>
          <Col lg={3}>
            <div className="text-center tab-header">
              <h5 className="font-14 font-weight-bold heading-color">Rating</h5>
            </div>
          </Col>
        </Row>

        <Row className="g-0 border-top">
          <Col lg={9}>
            <div className="header-content border-end">
              <p className="font-13 mb-0">
                <span className="font-weight-s-bold heading-color">
                  {" "}
                  Job Knowledge:{" "}
                </span>
                <span className="font-weight-normal text-color">
                  (Understands and applies the principles and procedures
                  required by the job)​
                </span>
              </p>
            </div>
          </Col>
          <Col lg={3}>
            <div className="text-center header-content">
              <select className="border-0 text-color font-13 font-weight-normal">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
              </select>
            </div>
          </Col>
        </Row>
        <Row className="g-0 border-top">
          <Col lg={9}>
            <div className="header-content border-end">
              <p className="font-13 mb-0">
                <span className="font-weight-s-bold heading-color">
                  {" "}
                  Job Knowledge:{" "}
                </span>
                <span className="font-weight-normal text-color">
                  (Understands and applies the principles and procedures
                  required by the job)​
                </span>
              </p>
            </div>
          </Col>
          <Col lg={3}>
            <div className="text-center header-content">
              <select className="border-0 text-color font-13 font-weight-normal">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
              </select>
            </div>
          </Col>
        </Row>
        <Row className="g-0 border-top">
          <Col lg={9}>
            <div className="header-content border-end">
              <p className="font-13 mb-0">
                <span className="font-weight-s-bold heading-color">
                  {" "}
                  Job Knowledge:{" "}
                </span>
                <span className="font-weight-normal text-color">
                  (Understands and applies the principles and procedures
                  required by the job)​
                </span>
              </p>
            </div>
          </Col>
          <Col lg={3}>
            <div className="text-center header-content">
              <select className="border-0 text-color font-13 font-weight-normal">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
              </select>
            </div>
          </Col>
        </Row>
      </div>
      <Row className="my-3">
        <p className="font-13 font-weight-400 heading-color mb-3">Comments</p>
        <Col lg={12}>
          <div className="mb-3">
            <CKEditor
              editor={ClassicEditor}
              config={CK_CONFIGS(localStorage.getItem("token"))}
            />
          </div>
        </Col>
      </Row>
      <div className="mt-4">
        <button className="c-b-btn">Cancel</button>
        <button className="n-u-btn">Save </button>
      </div>
    </>
  );
};

export default TabsContent;
